import React, { useState, useMemo } from 'react';
import styles from '../styles.module.scss';
import { useSelector } from 'react-redux';
import { RootState } from '@Redux/search/store';
import useSearchPageGA from '../useSearchPageGA';
import { filterSeatAvailable } from '@utils/utils';
import { sorting } from '../utils';
import { SearchFlightIcon } from '@features/ui/Icons';

import ResultNoData from '@features/noResult/SearchNoData';
import Skeleton from '@features/skeletons';
import FlightCard from './FlightCard';
import { PromotionDeal } from '@features/announcements';

interface I_MProps {
    openPanelM: () => void;
}

const M = ({ openPanelM }: I_MProps) => {
    const { ShowData, SortType, SearchPrice, UrlParams } = useSelector((state: RootState) => state.search);
    const [currentPage, setCurrentPage] = useState(1); // 載入更多

    const lowestPriceData = useMemo(() => {
        const dataSortedWithLowestPrice = filterSeatAvailable(
            sorting(SearchPrice?.data?.FlightInfos, 'price')
        );
        return dataSortedWithLowestPrice ? dataSortedWithLowestPrice[0] : undefined;
    }, [SearchPrice]);

    const lowestTimeData = useMemo(() => {
        const dataSortedWithLowestTime = filterSeatAvailable(
            sorting(SearchPrice?.data?.FlightInfos, 'time')
        );
        return dataSortedWithLowestTime ? dataSortedWithLowestTime[0] : undefined;
    }, [SearchPrice]);

    const flightData = useMemo(
        () => sorting(ShowData?.data?.FlightInfos, SortType),
        [ShowData, SortType]
    );

    useSearchPageGA(flightData, currentPage, 'pc');

    const handlePageChange = () => setCurrentPage((prevPageNumber) => prevPageNumber + 1);

    if (SearchPrice.isLoading || !flightData) return <Skeleton part="cards" device="m" />;
    if (flightData && flightData.length > 0)
        return (
            <>
                {flightData &&
                    flightData.map((item, index) => {
                        if (index <= currentPage * 10) {
                            return (
                                <div key={index}>
                                    <FlightCard
                                        flightData={item}
                                        lowestPriceData={lowestPriceData}
                                        lowestTimeData={lowestTimeData}
                                    />
                                    {UrlParams.Rtow === '1' && index === 2 && <PromotionDeal />}
                                </div>
                            );
                        }
                    })}

                {flightData.length > currentPage * 10 && (
                    <div className={styles.moreInfoWrapper}>
                        <div className={styles.moreInfo} onClick={handlePageChange}>
                            查看更多機票
                        </div>
                    </div>
                )}
            </>
        );
    return (
        <ResultNoData
            icon={<SearchFlightIcon />}
            content="您選擇的日期/時段目前查無航班。建議你..."
            linkText="選擇其他日期後重新查詢"
            onLinkClick={openPanelM}
        />
    );
};

export default M;
